interface Props {
  height?: string;
  width?: string;
}

export const AdvisorViewIcon = ({ height = '32', width = '32' }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 9.1375C12.305 9.1375 13.3625 10.195 13.3625 11.5C13.3625 12.805 12.305 13.8625 11 13.8625C9.695 13.8625 8.6375 12.805 8.6375 11.5C8.6375 10.195 9.695 9.1375 11 9.1375ZM11 19.2625C14.3413 19.2625 17.8625 20.905 17.8625 21.625V22.8625H4.1375V21.625C4.1375 20.905 7.65875 19.2625 11 19.2625ZM11 7C8.51375 7 6.5 9.01375 6.5 11.5C6.5 13.9863 8.51375 16 11 16C13.4863 16 15.5 13.9863 15.5 11.5C15.5 9.01375 13.4863 7 11 7ZM11 17.125C7.99625 17.125 2 18.6325 2 21.625V25H20V21.625C20 18.6325 14.0038 17.125 11 17.125Z"
      fill="#424249"
    />
    <path d="M21 14L25.5 18L30 14H21Z" fill="#424249" />
  </svg>
);
